import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const ArticleCta = ({ section }) => {
  const isCareer = section === 'carriere';
  return (
    <section className="bg-[#E30022] text-white py-12 sm:py-16" aria-labelledby="article-cta-title">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 id="article-cta-title" data-testid="article-cta-title" className="text-base md:text-lg font-serif mb-4">
          {isCareer ? 'Prêt pour votre prochaine étape ?' : "Besoin d’accompagnement ?"}
        </h2>
        <p data-testid="article-cta-description" className="text-sm sm:text-base mb-6">
          {isCareer ? 'Déposez votre CV et laissez-nous vous accompagner vers de nouvelles opportunités.' : 'Nos consultants vous accompagnent dans la recherche des talents qui feront grandir votre entreprise.'}
        </p>
        <Link to={isCareer ? '/deposer-cv' : '/recrutement'} data-testid="article-cta-link"
          className="inline-flex max-w-full items-center justify-center gap-2 bg-white text-[#E30022] px-5 sm:px-8 py-3 rounded font-medium hover:bg-gray-100 transition-colors">
          {isCareer ? 'Déposer mon CV' : 'Confiez-nous vos recrutements'}
          <ArrowRight aria-hidden="true" className="h-4 w-4 shrink-0" />
        </Link>
      </div>
    </section>
  );
};